var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u05E9\u05E2\u05D5\u05DF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05E9\\u05E2\\u05D5\\u05DF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 13 0 13 13 0 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49442857,0.928571429 C3.419,0.928571429 0.928571429,3.42457143 0.928571429,6.5 C0.928571429,9.57542857 3.419,12.0714286 6.49442857,12.0714286 C9.57542857,12.0714286 12.0714286,9.57542857 12.0714286,6.5 C12.0714286,3.42457143 9.57542857,0.928571429 6.49442857,0.928571429 Z M6.5,10.9571429 C4.03742857,10.9571429 2.04285714,8.96257143 2.04285714,6.5 C2.04285714,4.03742857 4.03742857,2.04285714 6.5,2.04285714 C8.96257143,2.04285714 10.9571429,4.03742857 10.9571429,6.5 C10.9571429,8.96257143 8.96257143,10.9571429 6.5,10.9571429 Z M6.77857143,3.71428571 L5.94285714,3.71428571 L5.94285714,7.05714286 L8.86785714,8.81214286 L9.28571429,8.12685714 L6.77857143,6.63928571 L6.77857143,3.71428571 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteClock);
export default __webpack_public_path__ + "static/media/white-clock.d9e791c7cc92e1a1429bda6e14c22e34.svg";
export { ForwardRef as ReactComponent };